const columns = ['parentbusinessunitid', 'name'] as const;

export default { columns, fields: [] };
